export const BOOK_BUSINESS_BUTTON_TEXT = "Book Business Travel";
export const CONTINUE_BUTTON_TEXT = "Continue to Personal Travel";
export const SWITCH_MODAL_TITLE = "What are you trying to book?";
export const SWITCH_MODAL_SUBTITLE =
  "For all business travel needs, select “Book business travel” or access anytime via your profile menu dropdown. If you are looking to book personal travel, select “Continue to personal travel”.";
